export const CERTIFICATE_CATEGORY_LIST_REQUEST =
  "CERTIFICATE_CATEGORY_LIST_REQUEST";
export const CERTIFICATE_CATEGORY_LIST_SUCCESS =
  "CERTIFICATE_CATEGORY_LIST_SUCCESS";
export const CERTIFICATE_CATEGORY_LIST_FAIL = "CERTIFICATE_CATEGORY_LIST_FAIL";
export const CERTIFICATE_CATEGORY_LIST_RESET =
  "CERTIFICATE_CATEGORY_LIST_RESET";

export const CERTIFICATE_GET_BY_SLUG_REQUEST =
  "CERTIFICATE_GET_BY_SLUG_REQUEST";
export const CERTIFICATE_GET_BY_SLUG_SUCCESS =
  "CERTIFICATE_GET_BY_SLUG_SUCCESS";
export const CERTIFICATE_GET_BY_SLUG_FAIL = "CERTIFICATE_GET_BY_SLUG_FAIL";
export const CERTIFICATE_GET_BY_SLUG_RESET = "CERTIFICATE_GET_BY_SLUG_RESET";

export const PROBLEM_STATEMENT_LIST_REQUEST = "PROBLEM_STATEMENT_LIST_REQUEST";
export const PROBLEM_STATEMENT_LIST_SUCCESS = "PROBLEM_STATEMENT_LIST_SUCCESS";
export const PROBLEM_STATEMENT_LIST_FAIL = "PROBLEM_STATEMENT_LIST_FAIL";
export const PROBLEM_STATEMENT_LIST_RESET = "PROBLEM_STATEMENT_LIST_RESET";

// Get user registrations list
export const USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST =
  "USER_CERTIFICATTION_REGISTRATION_LIST_REQUEST";
export const USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS =
  "USER_CERTIFICATTION_REGISTRATION_LIST_SUCCESS";
export const USER_CERTIFICATTION_REGISTRATION_LIST_FAIL =
  "USER_CERTIFICATTION_REGISTRATION_LIST_FAIL";
export const USER_CERTIFICATTION_REGISTRATION_LIST_RESET =
  "USER_CERTIFICATTION_REGISTRATION_LIST_RESET";

// Create/Register for certification
export const USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST =
  "USER_CERTIFICATTION_REGISTRATION_CREATE_REQUEST";
export const USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS =
  "USER_CERTIFICATTION_REGISTRATION_CREATE_SUCCESS";
export const USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL =
  "USER_CERTIFICATTION_REGISTRATION_CREATE_FAIL";
export const USER_CERTIFICATTION_REGISTRATION_CREATE_RESET =
  "USER_CERTIFICATTION_REGISTRATION_CREATE_RESET";

// Submit GitHub link
export const USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST =
  "USER_CERTIFICATTION_REGISTRATION_SUBMIT_REQUEST";
export const USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS =
  "USER_CERTIFICATTION_REGISTRATION_SUBMIT_SUCCESS";
export const USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL =
  "USER_CERTIFICATTION_REGISTRATION_SUBMIT_FAIL";
export const USER_CERTIFICATTION_REGISTRATION_SUBMIT_RESET =
  "USER_CERTIFICATTION_REGISTRATION_SUBMIT_RESET";

export const USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE =
  "USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_SAVE";
export const USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL =
  "USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_FAIL";
export const USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET =
  "USERREGISTRATION_GRAB_CERTIFICATE_EACHCARD_RESET";

export const ADMIN_SUBMISSIONS_LIST_REQUEST = "ADMIN_SUBMISSIONS_LIST_REQUEST";
export const ADMIN_SUBMISSIONS_LIST_SUCCESS = "ADMIN_SUBMISSIONS_LIST_SUCCESS";
export const ADMIN_SUBMISSIONS_LIST_FAIL = "ADMIN_SUBMISSIONS_LIST_FAIL";
export const ADMIN_SUBMISSIONS_LIST_RESET = "ADMIN_SUBMISSIONS_LIST_RESET";

// Mark submission as completed
export const ADMIN_MARK_COMPLETED_REQUEST = "ADMIN_MARK_COMPLETED_REQUEST";
export const ADMIN_MARK_COMPLETED_SUCCESS = "ADMIN_MARK_COMPLETED_SUCCESS";
export const ADMIN_MARK_COMPLETED_FAIL = "ADMIN_MARK_COMPLETED_FAIL";
export const ADMIN_MARK_COMPLETED_RESET = "ADMIN_MARK_COMPLETED_RESET";

export const BUNDLE_PRICING_REQUEST = "BUNDLE_PRICING_REQUEST";
export const BUNDLE_PRICING_LIST_SUCCESS = "BUNDLE_PRICING_LIST_SUCCESS";
export const BUNDLE_PRICING_LIST_FAIL = "BUNDLE_PRICING_LIST_FAIL";
export const BUNDLE_PRICING_LIST_RESET = "BUNDLE_PRICING_LIST_RESET";

export const SOLO_PRICING_REQUEST = "SOLO_PRICING_REQUEST";
export const SOLO_PRICING_SUCCESS = "SOLO_PRICING_SUCCESS";
export const SOLO_PRICING_FAIL = "SOLO_PRICING_FAIL";
export const SOLO_PRICING_RESET = "SOLO_PRICING_RESET";
